import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const links = [{
    name: 'Accueil',
    href: '/'
  }, {
    name: 'À Propos',
    href: '/about'
  }, {
    name: 'Nos Actions',
    href: '/actions'
  }, {
    name: 'Notre Vision',
    href: '/impact'
  }, {
    name: 'Blog',
    href: '/blog'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="bg-white border-b border-gray-100 sticky top-0 z-50" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="flex justify-between h-28" data-id="element-83">
          <div className="flex items-center" data-id="element-84">
            <Link to="/" className="flex-shrink-0 flex items-center gap-3" data-id="element-85">
              <img src="https://cdn.magicpatterns.com/uploads/qCb6hamLArrr2SMb6t4UDJ/ADCC_logo.png" alt="ADCC - Association Dignité Compétence Création" className="h-20 w-auto max-w-[250px] object-contain" data-id="element-86" />
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex md:items-center md:space-x-8" data-id="element-87">
            {links.map(link => <Link key={link.name} to={link.href} className={`text-sm font-medium transition-colors ${isActive(link.href) ? 'text-[#1E88E5]' : 'text-gray-600 hover:text-[#1E88E5]'}`} data-id="element-88">
                {link.name}
              </Link>)}

            <Link to="/donate" data-id="element-89">
              <Button variant="primary" size="sm" className="gap-2" data-id="element-90">
                <Heart className="w-4 h-4" data-id="element-91" />
                Faire un don
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-92">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#1E88E5]" data-id="element-93">
              <span className="sr-only" data-id="element-94">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" aria-hidden="true" data-id="element-95" /> : <Menu className="block h-6 w-6" aria-hidden="true" data-id="element-96" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100" data-id="element-97">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-98">
            {links.map(link => <Link key={link.name} to={link.href} onClick={() => setIsOpen(false)} className={`block px-3 py-2 rounded-md text-base font-medium ${isActive(link.href) ? 'bg-blue-50 text-[#1E88E5]' : 'text-gray-600 hover:bg-gray-50 hover:text-[#1E88E5]'}`} data-id="element-99">
                {link.name}
              </Link>)}

            <div className="px-3 py-2 mt-2" data-id="element-100">
              <Link to="/donate" onClick={() => setIsOpen(false)} data-id="element-101">
                <Button variant="primary" className="w-full gap-2 justify-center" data-id="element-102">
                  <Heart className="w-4 h-4" data-id="element-103" />
                  Faire un don
                </Button>
              </Link>
            </div>
          </div>
        </div>}
    </nav>;
}